import {
  getIdNumberLabels,
  formatIdNumber,
  getPlaceholderText,
  parseIdNumber,
  getTestId,
} from "@certn/utils/";
import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { TextField, TextFieldProps } from "@certn/cascadia-react";

import { getCurrentRegion } from "../../../utils";

export type InputType = "password" | "text";

export interface IDNumberProps extends TextFieldProps {
  errorMessage?: ReactNode;
  validationState?: "valid" | "invalid";
  isDisabled?: boolean;
  length?: number;
  label?: string;
  isRequired?: boolean;
  country?: string;
  name: string;
}

export function IDNumberInput(props: IDNumberProps) {
  const { t } = useTranslation();

  const {
    value = "",
    onChange = () => {
      console.warn(
        "IdNumberInput: value changed but no change handler was specified."
      );
    },
    country = getCurrentRegion(),
    label = getIdNumberLabels(t, country),
  } = props;

  const [type, setType] = useState<InputType>("text");

  // Takes a raw value and formats for viewing, eg. 855-99-7777
  function formatValue(rawValue: string) {
    const displayText = formatIdNumber(rawValue, country);
    return displayText;
  }

  // Takes a formatted value and parses it into a raw backend val eg. 855997777
  function parseValue(formattedValue: string) {
    const newVal = parseIdNumber(formattedValue, country);
    onChange(newVal);
    return newVal;
  }

  useEffect(() => {
    if (value.length > 0) {
      setType("password");
    }
  }, [value.length]);

  return (
    <TextField
      label={label}
      hasIconRight
      type={type}
      icon={type === "text" ? "visibility" : "visibility_off"}
      placeholder={getPlaceholderText(country)}
      value={formatValue(value)}
      onChange={(val) => parseValue(val)}
      testID={`id-number-input-${getTestId(country)}`}
      isDisabled={props.isDisabled}
      onIconClick={(evt) => {
        evt.preventDefault();
        setType((type) => (type === "text" ? "password" : "text"));
      }}
      name={props.name}
      isRequired={props.isRequired}
      errors={props.errorMessage}
    />
  );
}
